import { ChevronLeft } from "@mui/icons-material";
import {
  Button,
  Collapse,
  FormControl,
  IconButton,
  Grid,
  Typography,
  Autocomplete,
  Box,
  Paper,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useGetTokenOrLogout } from "../../../../../utils/token";
import { useNavigate } from "react-router-dom";
import CustomTextFieldComp from "../../../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../../newComponent/AutocompleteComp";
import InputField from "../../../../newComponent/themeprovider/textField/InputFiledComp";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function StudentFilter({
  isOpen,
  setIsOpen,
 
 
 


 


  setFilteredData,
  setIsLoading,
  branchofEnquiry,
  setBranchOfEnquiry,

  OriginalStudentData,
  setStudents,
}) {
  const userId = localStorage.getItem("userId");
  const [name, setName] = useState("");
  const [statusname, setstatusname] = useState([]);
  const [branch, setBranch] = useState([]);
  const [examoption, setexamoption] = useState([]);
const [enrollmentNo, setEnrollmentNo] = useState("");
  // const [status, setStatus] = useState([]);
  const [enrollmentDateFrom, setEnrollmentDateFrom] = useState("");
  const [enrollmentDateTo, setEnrollmentDateTo] = useState("");

  const [examtype, setExamtype] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();

  const requestData = useMemo(() => ({
    enrollment_no: parseInt(enrollmentNo) || null,
    enrolled_from_date: enrollmentDateFrom || null,
    enrolled_to_date: enrollmentDateTo || null,
    status: statusname,
    branch_id: branch.map(i => i.id),
    user_id: parseInt(userId),
  }), [enrollmentNo, enrollmentDateFrom, enrollmentDateTo, statusname, branch, userId]);

  const handleFilter = async () => {

  

    const token = getTokenOrLogout();
    if (!token) return;

    setIsLoading(true);
    try {
      const response = await fetch(`${API_ENDPOINT}route/studentfilter`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();
        const sortedStudents = result.sort(
          (a, b) => new Date(b.joining_date) - new Date(a.joining_date)
        );
        setStudents(sortedStudents);
        setFilteredData(sortedStudents);
        setIsLoading(false);
      } else {
        navigate("/page500");
      }
    } catch (error) {
      console.error("Error:", error);
      navigate("/page500");
    }
  };

  const resetFilter = () => {
    // setCurrentPage(1);
    setName("");
    setBranch([]);
    setstatusname([]);
    setEnrollmentNo("");
    setStudents(OriginalStudentData);
    setIsOpen(false);
    setexamoption([]);
  };

  const handleEnrollmentDateFromChange = useCallback((e) => {
    setEnrollmentDateFrom(e.target.value);
  }, []);

  const handleEnrollmentDateToChange = useCallback((e) => {
    setEnrollmentDateTo(e.target.value);
  }, []);

  const status = ["active", "inactive"];

  const handelstatuschange = (event, value) => {
    setstatusname(value);
  };

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          setBranchlist(data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchBranch();
  }, []);

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];

  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  const formatDate = (date) => date.toISOString().split("T")[0];

  useEffect(() => {
    const today = new Date();
    let oneMonthAgo = new Date();
    oneMonthAgo.setDate(today.getDate() - 30);
    setEnrollmentDateTo(formatDate(today));
    setEnrollmentDateFrom(formatDate(oneMonthAgo));
  }, []);

  return (
    <Collapse in={isOpen}>
    

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6">Enrollment No</Typography>
            <CustomTextFieldComp
            size="normal"
              type="number"
              fullWidth
              value={enrollmentNo}
              onChange={(e) => setEnrollmentNo(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6">Enrollment Date From</Typography>
            <CustomTextFieldComp
              size="normal"
              type="date"
              fullWidth
              value={enrollmentDateFrom}
              onChange={handleEnrollmentDateFromChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6">Enrollment Date To</Typography>
            <CustomTextFieldComp
            size="normal"
              type="date"
              fullWidth
              value={enrollmentDateTo}
              onChange={handleEnrollmentDateToChange}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6">Status</Typography>
            <CustomAutocompleteComp
              size="normal"
              multiple
              fullWidth
              value={statusname}
              onChange={handelstatuschange}
              options={status}
              getOptionLabel={(option) => option}
              tooltipContent={(option)=>option}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6">Enrolled Branch</Typography>
            <CustomAutocompleteComp
              multiple
              fullWidth
              
              value={branch}
              onChange={handelbranchchange}
              options={allbranchList}
              getOptionLabel={(option) => option.branch_name}
              tooltipContent={(option) => option.branch_name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} display="flex"  gap={2} mt={2}>
            <Button variant="contained" color="primary" sx={{  width: "100px" }} onClick={handleFilter}>
              Filter
            </Button>
       
            <Button variant="contained" color="error"  sx={{ width: "100px" }} onClick={resetFilter}>
              Reset
            </Button>
          </Grid>
        </Grid>
   
    </Collapse>
  );
}